import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/admin',
    component: () => import('../views/Admin/AdminHome.vue'),
    meta: {
      requiresAuth: true
    },

    children: [
      {
        name: 'Home',
        path: '/',
        component: () => import('../views/Admin/Dashboard.vue')
      },
      {
        name: 'Dashboard',
        path: 'dashboard',
        component: () => import('../views/Admin/Dashboard.vue')
      },
      {
        name: 'PollAdmin',
        path: 'polls',
        component: () => import('../views/Admin/PollAdmin.vue')
      },
      {
        name: 'CreatePoll',
        path: 'polls/create',
        component: () => import('../components/Admin/Forms/AddEditPoll.vue')
      },
      {
        name: 'EditPoll',
        path: 'polls/edit/:pollId',
        component: () => import('../components/Admin/Forms/AddEditPoll.vue')
      },

      {
        name: 'UserAdmin',
        path: 'users',
        component: () => import('../views/Admin/UserAdmin.vue')
      },
      {
        name: 'ViewPoll',
        path: 'launch/:id',
        component: () => import('../views/Admin/LaunchAdmin.vue')
      },
      {
        name: 'ReportAdmin',
        path: 'reports',
        component: () => import('../views/Admin/ReportAdmin.vue')
      },
      {
        name: 'AppSettings',
        path: 'settings',
        component: () => import('../views/Admin/Settings.vue')
      },
      {
        name: 'AppGlobalAdmin',
        path: 'global',
        component: () => import('../views/Admin/GlobalAdmin.vue')
      }
    ]
  },
  {
    name: 'Login',
    path: '/admin/login',
    component: () => import('../views/Admin/Login.vue')
  },

  {
    path: '*',
    component: () => import('../views/UserLogin.vue')
  },

  {
    path: '/event/:eventId',
    component: () => import('../views/UserLogin.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth) {
    if (!store.state.token) {
      next({ path: '/admin/login' });
      return;
    }
  }
  next();
});

export default router;
